import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { ModalService } from '../../../core/services/modal.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-order-head-create-project',
  templateUrl: './order-head-create-project.component.html',
  styleUrls: ['./order-head-create-project.component.css']
})
export class OrderHeadCreateProjectComponent implements OnInit {
    orderInternalNo;

    public edit?: Edit;

    public selectListProjectManagers: Item[] = [];

    public saving = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.orderInternalNo = this.stateService.getStateParams()['order_internal_no'];
    }

    private async loadEdit() {
        if (!!this.orderInternalNo) {
            this.edit = (await this.datatask.Post(3672, { order_internal_no: this.orderInternalNo }))[0];
        }
    }

    private async loadProjectManagers() {
        this.selectListProjectManagers = await this.datatask.Post(2747);
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                const response = (await this.datatask.Post(3673, this.edit))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        this.loadEdit();
        this.loadProjectManagers();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    order_internal_no: string;
    project_name: string;
    description: string;
    portal_user_keyno_project_manager: string;
    businessco_no: string;
}
